//asset imports
import poetsCoverImg from "../../Assets/Images/poet-empress-cover.jpeg";
import poetsUKCoverImg from "../../Assets/Images/poet-empress-uk-cover.png";

//component imports
import PraiseSection from "../../Components/PraiseSection/PraiseSection";

//router imports
import { Link } from "react-router-dom";

//constant imports
import strings from "../../Constants/strings";

//style imports
import "../../Styling/section.scss";
import "./projectPoets.scss";

export default function ProjectPoets() {
    return (
        <section className='poets__projectPage'>
            <h3 className="poets__title">{strings.books.poets}</h3>
            
            <p className="poets__library-pick">
                <strong>A Library Reads pick!</strong>
            </p>
            <p className="poets__library-pick">
                <strong>A BBC Radio 2 Book Club pick!</strong>
            </p>
            
            <div className="poets__covers">
                <div className="poets__cover-container">
                    <div className="poets__cover-wrapper">
                        <img className="poets__cover" src={poetsCoverImg} loading="lazy" alt="The Poet Empress US cover"/>
                    </div>
                    <p className="poets__cover-label">US Cover</p>
                </div>
                <div className="poets__cover-container">
                    <div className="poets__cover-wrapper">
                        <img className="poets__cover-uk" src={poetsUKCoverImg} loading="lazy" alt="The Poet Empress UK cover"/>
                    </div>
                    <p className="poets__cover-label">UK Cover</p>
                </div>
            </div>
            
            <p className="poets__content"><strong>In this dark epic fantasy</strong>, a young rice farmer must change the fate of a dynasty by learning poetry magic—in a world where women are forbidden to read.</p>
            
            <div className="poets__preorder">
                <p className="poets__preorder-spiel">
                    <em>The Poet Empress</em> is now <a href="https://linktr.ee/ThePoetEmpress" target="new">out worldwide in English</a>, with translations in multiple languages to come!
                </p>
            </div>
            
            <p className="poets__content-warning">
                See content warnings <Link to="/content">here</Link>.
            </p>
            
            <PraiseSection />
        </section>
    )
}